export const MOUNT_SELECTOR = '.vue-lpu-schedule-mount'

export const TARGET_ATTR_CACHED_NAME = 'data-lpu-schedule-cached'
